/* Shopify integration for KneviraReviews. No inline executable configuration. */
(function (global) {
  'use strict';
  function summaryView(detail) {
    if (detail?.status === 'loading') return { text: 'Loading reviews…', status: 'loading' };
    const count = Number(detail?.count); const fiveStarCount = Number(detail?.fiveStarCount);
    if (detail?.status !== 'ready' || detail.count == null || detail.fiveStarCount == null || !Number.isInteger(count) || count < 0 || !Number.isInteger(fiveStarCount) || fiveStarCount < 0 || fiveStarCount > count) {
      return { text: 'Reviews unavailable', status: 'unavailable' };
    }
    return { text: fiveStarCount.toLocaleString('en-US') + (fiveStarCount === 1 ? ' five-star review · ' : ' five-star reviews · ') + count.toLocaleString('en-US') + (count === 1 ? ' total review' : ' total reviews'), status: 'ready' };
  }
  function configFrom(raw) {
    const config = JSON.parse(raw);
    if (!config || !config.product || typeof config.product.id !== 'string' || !config.product.id) throw new Error('Invalid review product configuration.');
    const origin = new URL(config.apiBase);
    if (origin.protocol !== 'https:' || origin.username || origin.password || origin.search || origin.hash || origin.pathname !== '/') throw new Error('Review API must be an HTTPS origin.');
    return { apiBase: origin.origin, product: { id: config.product.id, title: String(config.product.title || '') },
      identityProxy: '/apps/knevira-reviews/identity', loginUrl: config.loginUrl, pageSize: 6 };
  }
  if (typeof module === 'object' && module.exports) module.exports = { summaryView, configFrom };
  if (!global.document) return;
  const doc = global.document; const mounted = new Map();
  function updateSummary(productId, detail) {
    const view = summaryView(detail);
    doc.querySelectorAll('[data-kv-review-summary]').forEach(node => {
      if (node.getAttribute('data-kv-review-summary') !== productId) return;
      const text = node.querySelector('[data-kv-review-text]');
      if (text) text.textContent = view.text;
      node.dataset.status = view.status; node.setAttribute('aria-busy', String(view.status === 'loading'));
    });
  }
  function fallback(host, root) {
    const productId = host.getAttribute('data-kv-review-product') || '';
    updateSummary(productId, { status: 'unavailable' }); root.replaceChildren();
    const box = doc.createElement('div'); box.className = 'kv-reviews-fallback'; box.setAttribute('role', 'status');
    const text = doc.createElement('p'); text.textContent = 'Customer reviews are temporarily unavailable. Please try again.';
    const retry = doc.createElement('button'); retry.type = 'button'; retry.textContent = 'Retry reviews'; retry.addEventListener('click', () => mountHost(host));
    box.append(text, retry); root.append(box);
  }
  function mountHost(host) {
    if (mounted.has(host)) return;
    const root = host.querySelector('[data-kv-reviews-root]'); if (!root) return;
    let listener;
    try {
      const config = configFrom(host.getAttribute('data-kv-reviews-config'));
      if (!global.KneviraReviews?.mount) throw new Error('Reviews component is unavailable.');
      listener = event => {
        if (event.detail?.product === config.product.id) updateSummary(config.product.id, event.detail);
      };
      root.addEventListener('knevira:reviews-summary', listener);
      const widget = global.KneviraReviews.mount(root, config);
      mounted.set(host, { widget, root, listener });
    } catch (_) { if (listener) root.removeEventListener('knevira:reviews-summary', listener); fallback(host, root); }
  }
  function boot(container = doc) {
    if (container.matches?.('[data-kv-reviews]')) mountHost(container);
    container.querySelectorAll('[data-kv-reviews]').forEach(mountHost);
  }
  function unload(container) {
    mounted.forEach((entry, host) => {
      if (host === container || container.contains(host)) {
        entry.root.removeEventListener('knevira:reviews-summary', entry.listener); entry.widget.destroy(); mounted.delete(host);
      }
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', () => boot(), { once: true }); else boot();
  doc.addEventListener('shopify:section:load', event => boot(event.target));
  doc.addEventListener('shopify:section:unload', event => unload(event.target));
})(typeof window !== 'undefined' ? window : globalThis);
